const Sentry = require('@sentry/browser')

const {
  asyncHandleFileSelected,
} = require('./jimp')
const {
  unset,
  pluck,
  isFile,
  flatten,
  isArray,
  endsWith,
  getWeeks,
  includes,
  isString,
  findWith,
  isObject,
  getUnique,
  findIndex,
  arrayFrom,
  isElement,
  getTypeof,
  isBooleand,
  whereNotIn,
  createFile,
  regExpTest,
  isFileList,
  getTheFirst,
  getFileName,
  isUndefined,
  getBoolValue,
  arrayCombine,
  randomString,
  getKeysObject,
  dataURLtoFile,
  checkVariable,
  getBase64Image,
  getLastIndexOf,
  getObjectValue,
  getAmountOfKeys,
  concatEcmascript,
  toYYYYMMDDString,
  createListNumber,
  arrayCombineWith,
  dateFormatSettings,
  getFirstOccurrence,
  momentCustomFormat,
  removeItemFromArray,
  mobileAndTabletcheck,
  getParameterOfTheUrl,
  urlBase64ToUint8Array,
  getTheFirstOccurrenceByKey,
  getFirstOccurrenceInObject,
  createTheParametersOfTheUrl,
  asyncTakeCareOfCompressingOnly,
} = require('../../../plugins/helper')
const HTML = require('../html/html').default
const { connect } = require('../../../plugins/notificationHelper')
const { objectToFormData, cleanData } = require('../../../plugins/objectToFormData')

/**
 * @param {String|Array} keys
 * @return {*}
 */
exports.getValueSetting = function (keys) {
  if ((this.getTypeof(window) === 'object' && this.object(window.config)) && (this.string(keys) || this.array(keys))) {
    return this.getObjectValue(window.config, keys)
  }

  return undefined
}

/**
 * @param {Object} err
 */
exports.captureException = function (err) {
  // Error Unprocessable Entity
  if (err && err.status === 422) {
    return false
  }

  const { sentryUrl, user } = window.config
  if (sentryUrl) {
    Sentry.init({ dsn: sentryUrl })
  }
  if (user && user.id !== null) {
    Sentry.configureScope(function (scope) {
      const { id, email, name } = user
      scope.setUser({ id, email, username: name })
    })
  } else if (user && user.id === null) {
    Sentry.configureScope(function (scope) {
      scope.setUser({ id: 1, email: 'desarrollo@weirdolabs.me', username: 'Weirdo Labs' })
    })
  }

  try {
    const exception = err.error || err.message || err.originalError || err
    Sentry.captureException(exception)
  } catch (error) {
    console.log(error)
  }
}

/**
 * @param {Mixed} values
 * @return {Boolean}
 */
exports.getTypeof = function (value) {
  return getTypeof(value)
}

/**
 * @param {Mixed} values
 * @return {Boolean}
 */
exports.checkVariable = function (values) {
  return checkVariable(values)
}

/**
* Check if argument is a string.
* @param {Object} value
* @return {Boolean}
*/
exports.string = function (value) {
  return isString(value)
}

/**
* Check if argument is a array.
* @param {Object} value
* @return {Boolean}
*/
exports.array = function (value) {
  return isArray(value)
}

/**
* Check if argument is a file.
* @param {Object} value
* @return {Boolean}
*/
exports.file = function (value) {
  return isFile(value)
}

/**
 * @param {Array} arraya
 * @param  {...any} arrayb
 */
exports.concat = function (arraya, arrayb) {
  return concatEcmascript(arraya, arrayb)
}

/**
* Check if the argument is a file list.
* @param {Object} value
* @return {Boolean}
*/
exports.fileList = function (value) {
  return isFileList(value)
}

/**
 * Check if argument is a HTML element.
 * @param {Object|String} value
 * @return {Boolean}
 */
exports.node = function (value) {
  if ((this.string(value)) && (endsWith(value, '.', 1) === true || endsWith(value, '#', 1) === true || ['body', 'html', 'meta'].indexOf(value) !== -1)) {
    const dom = document.querySelector(value)

    return this.node(dom)
  }

  return value !== undefined && value instanceof HTMLElement
}

/**
 * Check if argument is a HTML element.
 * @param {HTMLElement} content
 * @param {Object|String} value
 * @return {Boolean}
 */
exports.nodeWith = function (content, value) {
  if ((this.string(value)) && (endsWith(value, '.', 1) === true || endsWith(value, '#', 1) === true)) {
    const dom = content.querySelector(value)

    return this.nodeWith(content, dom)
  }

  return value !== undefined && value instanceof HTMLElement
}

/**
 * @param {String} value
 * @return {Boolean}
 */
exports.getNode = function (value) {
  if (this.string(value) && /^(.|#)/.test(value) || (['body', 'html', 'meta'].indexOf(value) !== -1)) {
    return document.querySelector(value)
  }

  return undefined
}

/**
 * @param {HTMLElement} content
 * @param {String} value
 * @return {Boolean}
 */
exports.getNodeWith = function (content, value) {
  if (this.node(content) && this.string(value) && /^(.|#)/.test(value)) {
    return content.querySelector(value)
  }

  return undefined
}

/**
 * @param {HTMLElement|String} content
 * @param {String} value
 * @return {Boolean}
 */
exports.getNodeWithAll = function (content, value) {
  if (this.node(content) && this.string(value) && /^(.|#)/.test(value)) {
    if (this.string(content)) {
      return this.getNodeWithAll(document.querySelector(content), value)
    }

    return content.querySelectorAll(value)
  }

  return undefined
}

/**
* Check if argument is a mixed.
* @param {Element|Object} value
* @return {Boolean}
*/
exports.isElement = function (value) {
  return isElement(value)
}

/**
 * Check if argument is a Object.
 * @param {Object} value
 * @return {Boolean}
 */
exports.object = function (value) {
  return isObject(value)
}

/**
* Check if argument is a list of HTML elements.
* @param {Object} value
* @return {Boolean}
*/
exports.nodeList = function (value) {
  const type = Object.prototype.toString.call(value)

  return value !== undefined
    && (type === '[object NodeList]' || type === '[object HTMLCollection]')
    && ('length' in value)
    && (value.length === 0 || exports.node(value[0]))
}

/**
* Check if argument is a SVG element.
* @param {Object} value
* @return {Boolean}
*/
exports.svg = function (value) {
  return value !== undefined && value instanceof SVGElement
}

/**
* Check if argument is a function.
* @param {Object} value
* @return {Boolean}
*/
exports.fn = function (value) {
  const type = Object.prototype.toString.call(value)

  return type === '[object Function]'
}

/**
 * Helper function to retrieve attribute value.
 * @param {HTMLElement} element
 * @param {String} suffix
 * @return {*}
 */
exports.getAttributeValue = function (element, suffix) {
  const attribute = `data-${suffix}`
  if (!element.hasAttribute(attribute)) {
    return
  }

  return element.getAttribute(attribute)
}

/**
 * Helper function to retrieve attribute value.
 * @param {HTMLElement} element
 * @param {String} attribute
 * @return {*}
 */
exports.getUniqueAttribute = function (element, attribute) {
  if (!element.hasAttribute(attribute)) {
    return
  }

  return element.getAttribute(attribute)
}

/**
 * @param {HTMLElement} element
 * @param {String} suffix
 * @return {*}
 */
exports.getHasAttribute = function (element, suffix) {
  const withSuffix = /^(data)/.test(suffix)
  if (withSuffix === true && !element.hasAttribute(suffix)) {
    return false
  }
  if (withSuffix === false && !element.hasAttribute(`data-${suffix}`)) {
    return false
  }

  return true
}

/**
 * @param {HTMLElement} element
 * @param {String} name
 * @param {String} value
 * @return {HTMLElement}
 */
exports.setAttribute = function (element, name, value) {
  return element.setAttribute(name, value)
}

exports.removeAttribute = function (element, name) {
  if (!element.hasAttribute(name)) {
    return
  }

  return element.removeAttribute(name)
}

/**
 * @param {Object} obj
 * @param {Function} fd
 * @param {*} pre
 * @return {Object}
 */
exports.objectToFormData = function (obj, fd, pre) {
  return objectToFormData(obj, fd, pre)
}

/**
 * @param {FormData} fd
 * @param {Array} keys
 * @return {FormData}
 */
exports.cleanData = function (fd, keys) {
  return cleanData(fd, keys)
}

/**
 * @param {HTMLElement} element
 * @param {Array} keys
 * @return {Object}
 */
exports.getAttributeValues = function (element, keys) {
  if (!this.array(keys) || !this.node(element)) {
    return null
  }

  const params = {}
  const self = this
  Array.prototype.forEach.call(keys, function (key) {
    const value = self.getAttributeValue(element, key)
    if (self.checkVariable(value)) {
      params[key] = value
    }
  })

  return params
}

/**
 * @param {String} dataurl
 * @param {String} filename
 * @return {File}
 */
exports.dataURLtoFile = function (dataurl, filename) {
  return dataURLtoFile(dataurl, filename)
}

/**
 * @param {HTMLElement|File}
 * @return {Promise}
 */
exports.asyncTakeCareOfCompressingOnly = (inputField, clientWidth, clientHeight) => {
  if (!this.file(inputField) && !this.node(inputField)) {
    return null
  }

  return asyncTakeCareOfCompressingOnly(inputField, clientWidth, clientHeight)
}

/**
 * @param {HTMLElement} inputField
 * @param {HTMLElement} containerInput
 * @param {HTMLElement} spinner
 * @param {HTMLElement} button
 * @return {Promise}
 */
exports.asyncHandleFileSelected = (inputField, containerInput, spinner, button) => {
  return asyncHandleFileSelected(inputField, containerInput, spinner, button)
}

/**
 * Crea un objeto con los parametros de una url.
 * Example: ?ejemplo=3
 * @param {String} url
 * @return {Object}
 */
exports.getParameterOfTheUrl = function (url) {
  return getParameterOfTheUrl(url)
}

/**
 * Crear los parámetros correctos que serán
 * enviado usando petición GET
 * @param {Object} options
 * @return {String}
 */
exports.createTheParametersOfTheUrl = function (options) {
  return createTheParametersOfTheUrl(options)
}

/**
 * @param {Object} datos
 * @return {Array}
 */
exports.arrayFrom = function (datos) {
  return arrayFrom(datos)
}

/**
 * @param {Array} args
 * @return {Array}
 */
exports.argsToParamsDefault = function (args) {
  const self = this
  const allParams = []
  if (self.checkVariable(args) && self.array(args)) {
    Array.prototype.forEach.call(args, datos => {
      if (self.array(datos)) {
        Array.prototype.forEach.call(datos, dato => {
          allParams.push(dato)
        })
      } else if (this.object(datos)) {
        allParams.push(datos)
      }
    })
  }

  return allParams
}

/**
 * @param {*} args
 * @return {Object}
 */
exports.argsToParams = function (args) {
  const params = {}
  if (this.checkVariable(args) && this.object(args[0])) {
    Object.assign(params, args[0])
  } else {
    const self = this
    Array.prototype.forEach.call(['title', 'html', 'icon'], (name, index) => {
      const arg = args[index]
      if (self.checkVariable(arg)) {
        params[name] = arg
      }
    })
  }

  return params
}

/**
 * @param {Object} datos
 * @param {String} key
 * @return {Mixed}
 */
exports.getObjectValue = function (datos, key) {
  return getObjectValue(datos, key)
}

/**
 * @param {HTMLElement} element
 * @param {String|Array} classes
 * @return {HTMLElement}
 */
exports.addClass = function (element, ...classes) {
  if (this.node(element)) {
    element.classList.add(classes)
  }

  return element
}

/**
 * @param {HTMLElement} element
 * @param {String|Array} classes
 * @return {HTMLElement}
 */
exports.removeClass = function (element, ...classes) {
  if (this.node(element)) {
    element.classList.remove(classes)
  }

  return element
}

/**
 * @param {HTMLElement} element
 * @param {String} classs
 * @return {Boolean}
 */
exports.hasClass = function (element, classs) {
  if (this.node(element)) {
    return element.classList.contains(classs)
  }

  return false
}

/**
 * @param {HTMLElement} element
 * @param {String} toggle
 * @return {HTMLElement}
 */
exports.toggle = function (element, toggle) {
  element.classList.toggle(toggle)

  return element
}

/**
 * DOM element creation abstraction
 * @param {String} elementType
 * @param {{}} [extraParameters]
 * @param {Array} [children]
 * @returns {HTMLElement}
 */
exports.make = function (elementType, extraParameters, children) {
  return HTML.make(elementType, extraParameters, children)
}

/**
 * Converts string to text node
 * @param {String} string
 * @returns {Text}
 */
exports.text = function (string) {
  return HTML.text(string)
}

/**
 * Generates select input with list of children
 * @param optionArray
 * @param extraParameters
 * @param {String|int} [selectedValue]
 * @returns {HTMLElement}
 */
exports.select = function (optionArray, extraParameters, selectedValue) {
  return HTML.select(optionArray, extraParameters, selectedValue)
}

/**
 * This method clears every children a parent has
 * @param {HTMLElement|Node} target
 * @param {boolean} [alsoParent]
 */
exports.destroyChildrenOf = function (target, alsoParent) {
  HTML.destroyChildrenOf(target, alsoParent)
}

/**
 * @param {String|HTMLElement} element
 * @param {HTMLElement} child
 */
exports.elementAppendChild = function (element, child) {
  if (this.string(element)) {
    document.querySelector(element).appendChild(child)
  } else {
    element.appendChild(child)
  }
}

/**
 * @param {HTMLCollection|NodeList} content
 * @param {HTMLElement} element
 * @return {NUmber}
 */
exports.checkIfChildElementExists = function (content, element) {
  let index = 0
  const childs = content.children
  if (this.checkVariable(childs) && childs.length === 0) {
    return -1
  }
  while (index < childs.length) {
    const current = this.checkVariable(childs[index]) ? childs[index] : null
    if (this.checkVariable(current) && this.getUniqueAttribute(current, 'id') === this.getUniqueAttribute(element, 'id')) {
      return index
    }
    index++
  }

  return -1
}

/**
 * @param {Array} datos
 * @param {String|Number} value
 * @return {Mixed}
 */
exports.getFirstOccurrence = function (datos, value) {
  return getFirstOccurrence(datos, value)
}

/**
 * Formato: 30-11-2019 Tipo 1:
 * retorna 2019-11-30
 *
 * Formato: 30-11-2019 Tipo 2:
 * retorna 2019-30-11
 *
 * Formato: 30-11-2019 Tipo 3:
 * retorna 30-11-2019
 * @param {String} date
 * @param {Number} type
 * @return {String}
 */
exports.dateFormatSettings = function (date, type) {
  return dateFormatSettings(date, type)
}

/**
 * @param {String} date
 * @param {String|Array} format
 * @return {moment}
 */
exports.momentCustomFormat = (date, format) => {
  return momentCustomFormat(date, format)
}

/**
 * @param {Array|Object} datos
 * @param {Object|String|Number} value
 * @return {Mixed}
 */
exports.getFirstOccurrenceInObject = function (datos, value) {
  return getFirstOccurrenceInObject(datos, value)
}

/**
 * @param {Array} datos
 * @param {String|Array} pull
 * @return {Array}
 */
exports.pluck = function (datos, pull) {
  return pluck(datos, pull)
}

/**
 * Contrae un arreglo de matrices en un unico arreglo plano.
 * @param {Array} array
 * @return {Array}
 */
exports.flatten = function (array) {
  return flatten(array)
}

/**
 * @param {Array} datos
 * @param {Object} value
 * @param {String} key
 * @return {Boolean}
 */
exports.includes = function (datos, value, key) {
  return includes(datos, value, key)
}

/**
 * @param {Array} datos
 * @param {String} value
 */
exports.findIndex = function (datos, value) {
  return findIndex(datos, value)
}

/**
 * @param {Array} datos
 * @param {Function} predicate
 * @param {Number} fromIndex
 */
exports.findWith = function (datos, predicate, fromIndex) {
  return findWith(datos, predicate, fromIndex)
}

/**
 * @param {Array|Object} value
 * @return {Number}
 */
exports.getAmountOfKeys = function (value) {
  return getAmountOfKeys(value)
}

/**
 * @param {Number} length
 * @return {String}
 */
exports.randomString = function (length) {
  return randomString(length)
}

/**
 * @param {Object} object
 */
exports.getKeysObject = function (object) {
  return getKeysObject(object)
}

/**
 * @param {Array} datos
 * @param {String|Number} value
 * @param {Boolean} removed
 * @return {Array}
 */
exports.removeItemFromArray = function (datos, value, removed) {
  return removeItemFromArray(datos, value, removed)
}

/**
 * @param {Number} timer
 * @return {Promise}
 */
exports.waitInAWhile = function (timer) {
  return new Promise(resolve => setTimeout(resolve, timer))
}

/**
 * @param {Array} datos
 * @param {Array} header
 * @return {Array}
 */
exports.arrayCombine = function (datos, header) {
  return arrayCombine(datos, header)
}

/**
 * @param {Array} datos
 * @param {Array} header
 * @return {Array}
 */
exports.arrayCombineWith = function (datos, header) {
  return arrayCombineWith(datos, header)
}

/**
 * @param {Array} datos
 * @param {Array} header
 */
exports.doToArrayObject = datos => {
  if (!this.array(datos)) {
    datos = this.arrayFrom(datos)
  }
  const term = []
  term.push({ 0: '-- SELECCIONAR --' })
  Object.keys(datos).forEach(index => {
    const t = {}
    const data = datos[index]
    t[data.id] = data.name
    term.push(t)
  })

  return term
}

/**
 * @param {String} value
 * @param {String} searchString
 * @return {Number}
 */
exports.getLastIndexOf = function (value, searchString) {
  return getLastIndexOf(value, searchString)
}

/**
 * @param {String} date
 * @return {Array}
 */
exports.getWeeks = function (date) {
  return getWeeks(date)
}

/**
 * @param {Number} number
 * @param {String} type
 * @return {Array}
 */
exports.createListNumber = function (number, type) {
  return createListNumber(number, type)
}

/**
 * @param {Array} datos
 * @return {*}
 */
exports.getTheFirst = function (datos) {
  if (this.getAmountOfKeys(datos) > 0 && !this.fileList(datos)) {
    const first = getTheFirst(datos)
    if (this.array(first)) {
      return first[0]
    }

    return first
  } else if (this.getAmountOfKeys(datos) > 0 && this.fileList(datos)) {
    return datos[0]
  }

  return null
}

/**
 * @param {String} root
 * @param {String} delimiter
 * @return {String}
 */
exports.getFileName = function (root, delimiter) {
  return getFileName(root, delimiter)
}

/**
 * @param {File} file
 * @return {Promise}
 */
exports.createFileObjectImage = function (file) {
  if (!this.file(file)) {
    return null
  }

  return new Promise(resolve => {
    const src = URL.createObjectURL(file)
    const reader = new Image()
    reader.src = src
    reader.onload = (function (theFile) {
      resolve({ event: theFile, file: this })
    })
  })
}

/**
 * @param {File} file
 * @param {String} filename
 * @return {File}
 */
exports.createFile = function (file, filename) {
  return createFile(file, filename)
}

/**
 * @param {HTMLImageElement} img
 * @return {String}
 */
exports.getBase64Image = function (img) {
  return getBase64Image(img)
}

/**
 * @param {HTMLElement} img
 * @return {Boolean}
 */
exports.isPortrait = function (img) {
  const w = img.naturalWidth || img.width
  const h = img.naturalHeight || img.height

  return (h > w)
}

/**
 * @param {String} pattern
 * @param {String} test
 * @return {Boolean}
 */
exports.regExpTest = function (pattern, test) {
  return regExpTest(pattern, test)
}

/**
 * @return {*}
 */
exports.connectEcho = () => {
  return connect()
}

/**
 * @param {Array} datos
 * @param {String|Number} values
 * @param {Array|String} keys
 * @return {Array}
 */
exports.whereNotIn = (datos, values, keys) => {
  return whereNotIn(datos, values, keys)
}

/**
 * @param {Array|Object} datos
 * @param {Object|String|Number} value
 * @param {String} key
 * @return {Mixed}
 */
exports.getTheFirstOccurrenceByKey = (datos, value, key) => {
  return getTheFirstOccurrenceByKey(datos, value, key)
}

/**
 * @param {Array} datos
 * @return {Array}
 */
exports.getUnique = (datos) => {
  return getUnique(datos)
}

/**
 * @param {String} base64String
 * @return {Uint8Array}
 */
exports.urlBase64ToUint8Array = base64String => {
  return urlBase64ToUint8Array(base64String)
}

exports.mobileAndTabletcheck = () => {
  return mobileAndTabletcheck()
}

/**
 * @param {*} value
 * @return {Boolean}
 */
exports.isBooleand = value => {
  return isBooleand(value)
}

/**
 * @param {*} value
 * @return {Boolean}
 */
exports.getBoolValue = value => {
  return getBoolValue(value)
}

/**
 * @param {*} value
 * @return {Boolean}
 */
exports.isUndefined = value => {
  return isUndefined(value)
}

/**
 * @param {Boolean} withNumber
 * @return {String}
 */
exports.getHashValue = (withNumber) => {
  if (!this.isUndefined(window) && !this.isUndefined(window.location) && this.checkVariable(window.location.hash)) {
    return withNumber === false ? window.location.hash.replace(/#/i, '') : window.location.hash
  }

  return ''
}

/**
 * @param {Array} withNumber
 * @return {FileList}
 */
exports.makeFileList = (files) => {
  const reducer = (dataTransfer, file) => {
    dataTransfer.items.add(file)

    return dataTransfer
  }

  return files.reduce(reducer, new DataTransfer()).files
}

/**
 * @param {String} type
 * @param {HTMLElement} element
 * @param {*} options
 * @return {Event}
 */
exports.createEvent = (type, element, options) => {
  const event = new Event(type, {
    bubbles: true,
    cancelable: true,
    ...options,
  })
  element.dispatchEvent(event)
  Object.defineProperty(event, 'target', { writable: false, value: element })

  return event
}

/**
 * @param {HTMLElement|String} content
 * @return {Array}
 */
exports.checkAll = (element) => {
  const tmp = []
  const inputs = this.getNodeWithAll(element, 'input')
  for (var i = 0; i < inputs.length; i++) {
    if (inputs[i].checked) {
      tmp.push(inputs[i])
    }
  }

  return tmp
}

/**
 * @param {HTMLElement|String} content
 * @return {Array}
 */
exports.getFormInputValues = (element) => {
  const tmp = []
  const inputs = this.getNodeWithAll(element, 'select,input')
  for (var i = 0; i < inputs.length; i++) {
    const t = {}
    t[inputs[i].name] = inputs[i].value
    tmp.push(t)
  }

  return tmp
}

/**
 * @param {Object} datos
 * @param {Array|string} path
 * @return {Boolean}
 */
exports.unset = (datos, path) => {
  return unset(datos, path)
}

/**
 * Devuelve la fecha en el formato (2019-05-28)
 * establecido en la función
 * @param {Date} date
 * @return {String|NaN}
 */
exports.toYYYYMMDDString = (date) => {
  return toYYYYMMDDString(date)
}
